const rawCarrierTiers = [
    {"value":"", "label":""},
    {"value":"TIER_1", "label":"Tier 1"},
    {"value":"TIER_2", "label":"Tier 2 (Medicare dep.)"},
    {"value":"TIER_3", "label":"Tier 3 (Medicare + Medicaid dep.)"},
    {"value":"TIER_4", "label":"Tier 4 (Facility dep.)"}
];

export default rawCarrierTiers;